import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { PublicLayout } from "@/components/PublicLayout";

import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";

import AdminLogin from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminProductForm from "@/pages/admin/AdminProductForm";
import AdminInquiries from "@/pages/admin/AdminInquiries";
import AdminSettings from "@/pages/admin/Settings";
import AdminContent from "@/pages/admin/Content";

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <ContentProvider>
                    <BrowserRouter>
                        <Toaster position="top-right" richColors closeButton />
                        <Routes>
                            <Route element={<PublicLayout />}>
                                <Route path="/" element={<Home />} />
                                <Route path="/products" element={<Products />} />
                                <Route path="/products/:slug" element={<ProductDetail />} />
                                <Route path="/about" element={<About />} />
                                <Route path="/contact" element={<Contact />} />
                            </Route>

                            <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
                            <Route path="/admin/login" element={<AdminLogin />} />
                            <Route
                                element={
                                    <ProtectedRoute>
                                        <AdminLayout />
                                    </ProtectedRoute>
                                }
                            >
                                <Route path="/admin/dashboard" element={<AdminDashboard />} />
                                <Route path="/admin/products" element={<AdminProducts />} />
                                <Route path="/admin/products/new" element={<AdminProductForm />} />
                                <Route path="/admin/products/:id/edit" element={<AdminProductForm />} />
                                <Route path="/admin/inquiries" element={<AdminInquiries />} />
                                <Route path="/admin/content" element={<AdminContent />} />
                                <Route path="/admin/settings" element={<AdminSettings />} />
                            </Route>

                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                    </BrowserRouter>
                </ContentProvider>
            </AuthProvider>
        </div>
    );
}

export default App;
